// 大字提示：伺服器回覆的訊息（金幣不夠、今天的免費將數用完了、簽到獲得金幣…）
//
// 長輩看得清楚的大字、置中顯示幾秒後自動消失；點一下也會關閉。各畫面共用。
//
// === 使用圖片 ===
// 無 — 純程式繪製（DOM overlay，不經 Phaser）

const NOTICE_ID = 'mahjong-notice';
const NOTICE_Z_INDEX = '1900'; // 低於連線中斷遮罩（2000）
const NOTICE_BG = 'rgba(40, 24, 10, 0.92)';
const NOTICE_BORDER = '3px solid #e7c26b'; // 金邊
const NOTICE_FONT_PX = 30;
const NOTICE_PADDING = '22px 40px';
const NOTICE_RADIUS_PX = 18;
const NOTICE_MAX_WIDTH = '80vw';
const NOTICE_SHOW_MS = 2800; // 顯示時間
const NOTICE_FADE_MS = 250;

let hideTimer: ReturnType<typeof setTimeout> | null = null;

export const showNotice = (message: string): void => {
  if (typeof document === 'undefined') return;
  document.getElementById(NOTICE_ID)?.remove();
  if (hideTimer) clearTimeout(hideTimer);
  const box = document.createElement('div');
  box.id = NOTICE_ID;
  box.textContent = message;
  Object.assign(box.style, {
    position: 'fixed',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    zIndex: NOTICE_Z_INDEX,
    background: NOTICE_BG,
    border: NOTICE_BORDER,
    color: '#fff8e7',
    fontSize: `${NOTICE_FONT_PX}px`,
    fontWeight: 'bold',
    fontFamily: 'system-ui, sans-serif',
    padding: NOTICE_PADDING,
    borderRadius: `${NOTICE_RADIUS_PX}px`,
    maxWidth: NOTICE_MAX_WIDTH,
    textAlign: 'center',
    lineHeight: '1.5',
    transition: `opacity ${NOTICE_FADE_MS}ms`,
    cursor: 'pointer',
  });
  const close = (): void => {
    box.style.opacity = '0';
    setTimeout(() => box.remove(), NOTICE_FADE_MS);
  };
  box.addEventListener('click', close);
  document.body.append(box);
  hideTimer = setTimeout(close, NOTICE_SHOW_MS);
};

/** 錯誤轉成給長輩看的訊息。 */
export const noticeFromError = (error: unknown): void =>
  showNotice(error instanceof Error ? error.message : '發生問題，請再試一次');
